var _excluded = ["text", "onClick", "isActive"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 0 9.885 2.115l8.37 8.385H0v3h18.255l-8.37 8.385L12 24l12-12L12 0Z"
  }));
};
ArrowSvg.defaultProps = {
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
};
import getTextColor from "../../../utils/getTextColor";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
import TextAtm from "../../atoms/TextAtm";
var Text = styled(TextAtm).withConfig({
  componentId: "sc-bo5cp0-0"
})([""]);
var Arrow = styled(ArrowSvg).withConfig({
  componentId: "sc-bo5cp0-1"
})(function (_ref) {
  var $isActive = _ref.$isActive,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["margin-left:", ";fill:", ";path{", ";transform:", ";}"], space(1.5), getTextColor(theme, $onColor, "high"), transition("transform"), !$isActive && "translateX(-100%)");
});
var Container = styled.div.withConfig({
  componentId: "sc-bo5cp0-2"
})(function (_ref2) {
  var $isActive = _ref2.$isActive,
    $onColor = _ref2.$onColor,
    theme = _ref2.theme;
  return css(["display:inline-flex;position:relative;align-items:center;cursor:pointer;&:hover{", "{color:", ";}", " path{transform:translateX(0);}}", ""], Text, getTextColor(theme, $onColor, "high"), Arrow, $isActive && css(["&::after{content:\"\";position:absolute;right:0;bottom:", ";left:0;height:", ";background:", ";}"], space(-1), unit(2), getTextColor(theme, $onColor, "high")));
});
function AnimatedLinkIndicatorMol(_ref3) {
  var text = _ref3.text,
    onClick = _ref3.onClick,
    isActive = _ref3.isActive,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(Container, _extends({
    onClick: onClick,
    $isActive: isActive,
    $onColor: onColor
  }, restProps), /*#__PURE__*/React.createElement(Text, {
    typography: "large3",
    emphasis: isActive ? "high" : "low"
  }, text), /*#__PURE__*/React.createElement(Arrow, {
    $isActive: isActive,
    $onColor: onColor
  }));
}
export default AnimatedLinkIndicatorMol;